import React, { useEffect, useState } from "react";
import { useLoginMutation } from "../../redux/api/authApi";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import MetaData from "../layout/MetaData";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const navigate = useNavigate();

    const [login, { isLoading }] = useLoginMutation();
    const { isAuthenticated } = useSelector((state) => state.auth);

    useEffect(() => {
        if (isAuthenticated) navigate("/");
    }, [isAuthenticated, navigate]);

    const submitHandler = async (e) => {
        e.preventDefault();
        if (!email || !password) {
            toast.error("Please fill in all fields!");
            return;
        }
        try {
            const res = await login({ email, password }).unwrap();
            if (res) {
                toast.success("Login successful! 💖");
                navigate("/");
            }
        } catch (err) {
            const backendMsg = err?.data?.message;
            let fallbackMsg = "Login failed. Please try again.";
            if (err?.status === 404) fallbackMsg = "Please register first.";
            else if (err?.status === 401) fallbackMsg = "Username or password incorrect.";
            toast.error(backendMsg || fallbackMsg);
        }
    };

    return (
        <>
            <MetaData title={"Login"} />
            <main className="main-content">
                <div className="login-wrapper">
                    <div className="login-card shadow-lg rounded-4">
                        <form onSubmit={submitHandler}>
                            <h2 className="mb-4 text-center fw-bold text" style={{ color: '#e04f6e' }}> Login💖</h2>

                            {/* Email */}
                            <div className="mb-3">
                                <label htmlFor="email_field" className="form-label fw-semibold" style={{ color: '#e04f6e' }}>
                                    Email
                                </label>
                                <input
                                    type="email"
                                    id="email_field"
                                    className="form-control rounded-3 p-2"
                                    name="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter your email"
                                />
                            </div>

                            {/* Password */}
                            <div className="mb-3">
                                <label htmlFor="password_field" className="form-label fw-semibold" style={{ color: '#e04f6e' }}>
                                    Password
                                </label>
                                <input
                                    type="password"
                                    id="password_field"
                                    className="form-control rounded-3 p-2"
                                    name="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Enter your password"
                                />
                            </div>

                            {/* Forgot Password */}
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <Link to="/password/forgot" className="link-secondary small" >
                                    Forgot Password?
                                </Link>
                                <Link to="/register" className="link-primary small">
                                    New User? Register
                                </Link>
                            </div>

                            {/* Button */}
                            <button
                                id="login_button"
                                type="submit"
                                className="btn w-100 py-2 fw-semibold View-btn"
                                disabled={isLoading}
                            >
                                {isLoading ? "Authenticating..." : "LOGIN"}
                            </button>
                        </form>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Login;

